export default __webpack_public_path__ + "static/media/codepen.aea2a43a.png";